import React, { useState, useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Divider,
  Box,
} from "@mui/material";
import MDButton from "components/MDButton";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { ReceiptPdf } from "./ReceiptPdf";
import { DownloadButton } from "./ReceiptDownload";

const DonationDialog = ({ donation }) => {
  const [open, setOpen] = useState(false);
  const printRef = useRef();

  const handlePrint = () => {
    const content = printRef.current;
    const printWindow = window.open("", "", "width=800,height=600");

    printWindow.document.write(`
      <html dir="rtl">
        <head>
          <title>إيصال تبرع</title>
          <style>
            body {
              font-family: Amiri, serif;
              direction: rtl;
              padding: 24px;
            }
            h2 { text-align: center; color: #2E7D32; }
            .row { margin-bottom: 8px; }
            .label { font-weight: bold; }
          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <>
      <MDButton color="success" size="small" onClick={() => setOpen(true)}>
        عرض الإيصال
      </MDButton>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent dir="rtl">
          <Box ref={printRef}>
            <Typography variant="h5" textAlign="center" color="success.main">
              إيصال تبرع
            </Typography>

            <Typography textAlign="center" color="success.main" mb={2}>
              جمعية أراكان الإنسانية
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography className="row">
                  <span className="label">رقم الطلب:</span> {donation.OrderId}
                </Typography>
                <Typography className="row">
                  <span className="label">اسم المتبرع:</span> {donation.user}
                </Typography>
                <Typography className="row">
                  <span className="label">البريد الإلكتروني:</span>{" "}
                  {donation.email}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography className="row">
                  <span className="label">المبلغ:</span> {donation.PurchAmount}{" "}
                  {donation.original_currency}
                </Typography>
                <Typography className="row">
                  <span className="label">الحالة:</span>{" "}
                  {donation.donation_status}
                </Typography>
                <Typography className="row">
                  <span className="label">تاريخ الدفع:</span>{" "}
                  {donation.TransactionDate}
                </Typography>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            <Typography fontWeight="bold" mb={1}>
              تفاصيل التبرع:
            </Typography>

            {donation.donation_items.map((item, i) => (
              <Typography key={i}>• {item.project}</Typography>
            ))}
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", px: 3 }}>
          <MDButton color="info" onClick={() => setOpen(false)}>
            إغلاق
          </MDButton>

          {/* <Box display="flex" gap={1}> */}
          {/* <MDButton color="info" onClick={handlePrint}>
              طباعة
            </MDButton> */}

          {/* <PDFDownloadLink
              document={<ReceiptPdf donation={donation} />}
              fileName={`donation-${donation.OrderId}.pdf`}
              //   document={<ReceiptPdf donation={donation} />}
              //   fileName={`donation-${donation.OrderId}.pdf`}
              style={{ textDecoration: "none" }}
            >
              {({ loading }) => (
                <MDButton color="success" disabled={loading}>
                  {loading ? "جاري التحضير..." : "تحميل PDF"}
                </MDButton>
              )}
            </PDFDownloadLink> */}
          {donation.ProcReturnCode === "00" && (
            <DownloadButton donation={donation} />
          )}
          {/* </Box> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DonationDialog;
